import { createContext, useCallback, useContext, useState } from 'react';
import { uploadAccountConsolidationFile } from '../../services/accountConsolidation';

const AccountConsolidationContext = createContext({
  uploadFile: () => {},
  response: null,
  setResponse: () => {},
});

export const useAccountConsolidation = () => {
  return useContext(AccountConsolidationContext);
};

const AccountConsolidationContextProvider = ({ children }) => {
  const [response, setResponse] = useState(null);

  const uploadFile = useCallback(async (formData) => {
    try {
      const data = await uploadAccountConsolidationFile(formData);
      setResponse(data);
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', 'ErrorFile.csv'); // or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      // handleApiError('error', 'An error occurred while uploading the file',error?.response?.status);
    }
  }, []);

  return (
    <AccountConsolidationContext.Provider
      value={{
        uploadFile,
        response,
        setResponse,
      }}
    >
      {children}
    </AccountConsolidationContext.Provider>
  );
};

export default AccountConsolidationContextProvider;
